import user from '../models/user';
import memberProfileApi from '../api/memberProfileApi';
import { generateParams } from '../functions/utils';
import dateFinder from '../models/dateFinder';
import friends from '../models/friends';
import memberProfileModel from '../models/memberProfile';
import newFeedItem from '../models/newFeedItem';
import note from '../models/note';
import photo from '../models/photo';
import photoAmateur from '../models/photoAmateur';
import photoGallery from '../models/photoGallery';
import travelPlan from '../models/travelPlans';
import validate from '../models/validate';
import group from '../models/group';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import {
  IMainPhoto,
  IMemberProfile,
  INote,
  IPhotoAmateur,
  IPhotoGallery,
  IUserLoginInfo,
  IValidate,
} from 'redhotpie-shared-lib/interfaces/IUser';
import { IFriend } from 'redhotpie-shared-lib/interfaces/IFriendUser';
import { ITravelPlan } from 'redhotpie-shared-lib/interfaces/ITravelPlan';
import { IDateFinderDetail } from 'redhotpie-shared-lib/interfaces/IDateFinder';
import Feed from '../models/newFeedItem';
import { IGroup } from 'redhotpie-shared-lib/types/clubProfile';

class MemberProfileService {
  getMemberProfile(userId: number): Promise<IApiResponse<IMemberProfile>> {
    return memberProfileApi.getMemberProfile(userId).then(res => {
      try {
        if (res.success) {
          const data = memberProfileModel.mappingObject(res.data);
          return {
            success: true,
            data,
            summaryProfile: user.mappingObjectCustomFriendAndFavorite(res.data),
            isProfileNotFound: !data.detail.isViewable,
          };
        }
        console.log('ERROR: memberProfileService/getMemberProfile:', res.message);
        if (res.message === 'Request timeout') {
          return { success: false, isRequestTimeout: true };
        }
        return {
          success: false,
          data: new memberProfileModel(),
          isProfileNotFound: true,
        };

        // return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getMemberProfile:', e);
        throw new Error('failed');
      }
    });
  }

  getMemberPhotos(userId: number): Promise<IApiResponse<IMainPhoto[]>> {
    return memberProfileApi.getMemberPhoto(userId).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: res.data.items ? photo.mappingObjects(res.data.items) : [photo.mappingObject(res.data)],
          };
        } else if (res.message === 'Request timeout') {
          return { success: false, isRequestTimeout: true };
        }
        console.log('ERROR: memberProfileService/getMemberPhoto:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getMemberPhoto:', res);
        throw new Error('failed');
      }
    });
  }

  getMemberPhotoAmateur(userId: number): Promise<IApiResponse<IPhotoAmateur[]>> {
    return memberProfileApi.getMemberPhotoAmateur(userId).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: res.data.items.length > 0 ? photoAmateur.mappingObjects(res.data.items) : [photoAmateur.mappingObject(res.data)],
          };
        }
        console.log('ERROR: memberProfileService/getMemberPhotoAmateur:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getMemberPhotoAmateur:', res);
        throw new Error('failed');
      }
    });
  }

  getMemberValidates(userId: number, params: any) {
    const optionParams = params ? generateParams(params) : null;
    return memberProfileApi.getMemberValidates(userId, optionParams).then(res => {
      console.log(res);
      try {
        if (res.success && res.data) {
          return {
            success: true,
            data: validate.mappingObjects(res.data.Data || []),
            total: res.data.Total,
          };
        }
        console.log('ERROR: memberProfileService/getMemberValidate:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getMemberValidate', res);
        throw new Error('failed');
      }
    });
  }

  getMemberFriends(userId: number, params: any): Promise<IApiResponse<IFriend[]>> {
    const optionParams = params ? generateParams(params) : null;
    return memberProfileApi.getMemberFriends(userId, optionParams).then(res => {
      try {
        if (res.success && res.data) {
          return {
            success: true,
            data: friends.mappingObjects(res.data.Data),
            total: res.data.Total,
          };
        }
        console.log('ERROR: memberProfileService/getMemberFriends:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getMemberFriends:', res);
      }
      return { success: false };
    });
  }

  getMemberTravelPlans(userId: number): Promise<IApiResponse<ITravelPlan[]>> {
    return memberProfileApi.getMemberTravelPlans(userId).then(res => {
      try {
        if (res.success && res.data.items) {
          return {
            success: true,
            data: travelPlan.mappingObjects(res.data.items),
          };
        }
        console.log('ERROR: memberProfileService/getMemberTravelPlans:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getMemberTravelPlans:', res);
        throw new Error('failed');
      }
    });
  }

  getMemberDateFinder(userId: number): Promise<IApiResponse<IDateFinderDetail[]>> {
    return memberProfileApi.getMemberDateFinder(userId).then(res => {
      try {
        if (res.success && res.data.items) {
          return {
            success: true,
            data: dateFinder.mappingObjects(res.data.items),
          };
        }
        console.log('ERROR: memberProfileService/getMemberDateFinder:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getMemberDateFinder:', res);
        throw new Error('failed');
      }
    });
  }

  getProfileGallery(userId: number): Promise<IApiResponse<IPhotoGallery[]>> {
    return memberProfileApi.getProfileGallery(userId).then(res => {
      try {
        if (res.success && res.data.items) {
          return {
            success: true,
            data: photoGallery.mappingObjects(res.data.items),
          };
        }
        console.log('ERROR: memberProfileService/getProfileGallery:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getProfileGallery:', res);
        throw new Error('failed');
      }
    });
  }

  postCreateValidation(userId: number, params: any): Promise<IApiResponse> {
    return memberProfileApi.postCreateValidation(userId, params).then(res => {
      try {
        return { success: res.success, message: res.message };
      } catch (e) {
        console.log('ERROR: memberProfileService/postCreateValidation:', res);
        throw new Error('failed');
      }
    });
  }

  patchUpdateValidation(userId: number, params: any): Promise<IApiResponse> {
    return memberProfileApi.patchUpdateValidation(userId, params).then(res => {
      try {
        return { success: res.success, message: res.message };
      } catch (e) {
        console.log('ERROR: memberProfileService/postCreateValidation:', res);
        throw new Error('failed');
      }
    });
  }

  postCreateFriend(userId: number, params: any): Promise<IApiResponse> {
    return memberProfileApi.postCreateFriend(userId, params).then(res => {
      try {
        return { success: res.success, message: res.message };
        // return res.message ? {success: false, data: res.message} : {success: true};
      } catch (e) {
        console.log('ERROR: memberProfileService/postCreateFriend:', res);
        throw new Error('failed');
      }
    });
  }

  postCreateDateFinderInterest(id: number): Promise<IApiResponse> {
    return memberProfileApi.postCreateDateFinderInterest(id).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data.Result };
        }
        console.log('ERROR: memberProfileService/postCreateDateFinderInterest:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/postCreateDateFinderInterest:', res);
        throw new Error('failed');
      }
    });
  }

  postCreateDateFinderUnInterest(id: number): Promise<IApiResponse> {
    return memberProfileApi.postCreateDateFinderUnInterest(id).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data.Result };
        }
        console.log('ERROR: memberProfileService/postCreateDateFinderUnInterest:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/postCreateDateFinderUnInterest:', res);
        throw new Error('failed');
      }
    });
  }

  getProfileNote(userId: number): Promise<IApiResponse> {
    return memberProfileApi.getProfileNote(userId).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: res.data && res.data.items.length > 0 ? note.mappingObjects(res.data.items) : [],
          };
        }
        console.log('ERROR: memberProfileService/getProfileNote:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getProfileNote:', res);
        throw new Error('failed');
      }
    });
  }

  postCreateNote(userId: number, params: any): Promise<IApiResponse<INote>> {
    return memberProfileApi.postCreateNote(userId, params).then(res => {
      try {
        return {
          success: res.success,
          data: res.success ? note.mappingObject(res.data) : undefined,
          message: res.message,
        };
        // if (res.success) {
        //     return {success: true, data: note.mappingObject(res.data)};
        // }
      } catch (e) {
        console.log('ERROR: memberProfileService/postCreateNote:', res);
        throw new Error('failed');
      }
    });
  }

  patchUpdateNote(nodeId: number, params: any): Promise<IApiResponse<INote>> {
    return memberProfileApi.patchUpdateNote(nodeId, params).then(res => {
      try {
        return {
          success: res.success,
          data: res.success && res.data !== null ? note.mappingObject(res.data) : undefined,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: memberProfileService/postCreateNote:', res);
        throw new Error('failed');
      }
    });
  }

  patchUpdateFriend(params: any): Promise<IApiResponse> {
    return memberProfileApi.patchUpdateFriend(params).then(res => {
      try {
        return { success: res.success, message: res.message };
      } catch (e) {
        console.log('ERROR: memberProfileService/postCreateNote:', res);
        throw new Error('failed');
      }
    });
  }

  getMemberFriendCount(userId: number) {
    return memberProfileApi.getFriendCount(userId).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data.Result };
        }
        console.log('ERROR: memberProfileService/getMemberFriendCount', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProfileService/getMemberFriendCount:', res);
        throw new Error('failed');
      }
    });
  }

  getMemberValidateCount(userId: number) {
    return memberProfileApi.getValidationCount(userId).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data.Result };
        }
        console.log('ERROR: memberProfileService/getMemberValidationCount', res.message);

        return res;
      } catch (e) {
        console.log('ERROR:  memberProfileService/getMemberValidationCount:', res);
        throw new Error('failed');
      }
    });
  }

  postCreateBlockUser(userId: number) {
    return memberProfileApi.postCreateBlockUser(userId).then(res => {
      try {
        return {
          success: res.success,
          data: { id: userId },
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR:  memberProfileService/getMemberValidationCount:', res);
        throw new Error('failed');
      }
    });
  }

  postCreateReportUser(userId: number, params: any): Promise<IApiResponse> {
    return memberProfileApi.postCreateReportUser(userId, params).then(res => {
      //  console.log(res,params);
      try {
        return {
          success: res.success,
          data: { id: userId },
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR:  memberProfileService/getMemberValidationCount:', res);
        throw new Error('failed');
      }
    });
  }

  getPhotoLikes(photoId: number, params: any): Promise<IApiResponse<IUserLoginInfo[]>> {
    return memberProfileApi.getPhotoLikes(photoId, params).then(res => {
      try {
        return { success: res.success, data: res.data?.Data ? user.mappingObjectsCustom(res.data.Data) : [], total: res.data.Total || 0 };
      } catch (e: any) {
        console.log('ERROR:  memberProfileService/getPhotoLikes:', res);
        return { success: false, message: e?.message || '' };
      }
    });
  }

  createUserPhotoLike(photoId: number): Promise<IApiResponse<IUserLoginInfo>> {
    return memberProfileApi.createUserPhotoLike(photoId).then(res => {
      try {
        return { success: res.success, data: user.mappingObjectCustom(res.data) };
      } catch (e) {
        console.log('ERROR:  memberProfileService/createUserPhotoLike:', res);
        throw new Error('failed');
      }
    });
  }

  deleteUserPhotoLike(photoId: number): Promise<IApiResponse<any>> {
    return memberProfileApi.deleteUserPhotoLike(photoId).then(res => {
      try {
        return { success: res.success };
      } catch (e: any) {
        console.log('ERROR:  memberProfileService/deleteUserPhotoLike:', res);
        return { success: false, message: e?.message || '' };
      }
    });
  }

  postCreateProfileView(id: number): Promise<IApiResponse> {
    return memberProfileApi.postCreateProfileView(id).then(res => {
      try {
        return {
          success: res.success,
        };
      } catch (e) {
        console.log('ERROR:  memberProfileService/postCreateProfileView:', res);
        throw new Error('failed');
      }
    });
  }

  checkPhotoStatus(id: number): Promise<IApiResponse> {
    return memberProfileApi.checkPhotoStatus(id).then(res => {
      try {
        return {
          isAvailable: res.data?.Status === 'Available',
          success: res.success,
        };
      } catch (e) {
        console.log('ERROR:  memberProfileService/checkPhotoStatus:', res);
        throw new Error('failed');
      }
    });
  }
  getProfileActivity(id: number): Promise<IApiResponse<Feed[]>> {
    return memberProfileApi
      .getProfileActivity(id)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: newFeedItem.mappingObjects(res.data.items || []),
            };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: memberProfileService/getProfileActivity:', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: memberProfileService/getProfileActivity:', e);
        return { success: false };
      });
  }

  getProfileGroups(userId: number, { page, size }: any): Promise<IApiResponse<IGroup[]>> {
    return memberProfileApi
      .getProfileGroups(userId, { page, size })
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: { groups: group.mappingObjects(res.data.Data), total: res.data.Total },
            };
          }
        }
        return res;
      })
      .catch(e => {
        console.warn('ERROR: memberProfileService/getProfileGroups', e);
        return { success: false };
      });
  }
}

export default new MemberProfileService();
